var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoAon = function SvgLogoAon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 53,
    fill: "none",
    viewBox: "0 0 65 53"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "imageAon",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#FAAF40",
    d: "M13.209 52.73V19.008H.13v-7.947c1.78.052 3.562-.088 5.312-.416a13.7 13.7 0 0 0 4.602-1.733 11.3 11.3 0 0 0 3.467-3.233A11.5 11.5 0 0 0 15.358.73h9.351v52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "#000",
    d: "m44.59.73 19.448 52H52.165L48.23 41.15H28.79L24.71 52.73h-11.5l19.655-52zm.659 31.902-6.552-19.066h-.148l-6.777 19.066z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#F58C40",
    d: "M13.209 52.73V39.28l11.5-16.978z"
  }))));
};
export default SvgLogoAon;